// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"muiButton_iconWrapper__1M-Cy"};